document.addEventListener('DOMContentLoaded', function () {
  function parseVariants(card) {
    const node = card.querySelector('.product-variants-json');
    if (!node) return [];
    try { return JSON.parse(node.textContent || '[]'); } catch (e) { console.error('LEEGO variant data error:', e); return []; }
  }

  function updateVariant(card) {
    const variants = parseVariants(card);
    if (!variants.length) return;

    const selects = Array.from(card.querySelectorAll('.variant-option'));
    const idInput = card.querySelector('form.leego-add-to-cart input[name="id"]');
    const buttons = Array.from(card.querySelectorAll('.add-cart-btn, .buy-now-btn'));
    const price = card.querySelector('.product-card-price');
    if (!idInput || !buttons.length) return;

    // Products with only one/default variant have no option selectors.
    // Always use the Liquid-selected variant in that case. Do not run an
    // option-matching routine against an empty option list, which can make
    // valid products appear SOLD OUT.
    let variant;
    if (!selects.length) {
      const currentId = String(idInput.value || '');
      variant = variants.find(function (v) { return String(v.id) === currentId; }) || variants[0];
    } else {
      const values = selects.map(function (select) { return select.value; });
      variant = variants.find(function (v) {
        return Array.isArray(v.options) && v.options.every(function (value, index) { return value === values[index]; });
      });

      // Keep option choices valid for the currently selected combination.
      selects.forEach(function (select, index) {
        Array.from(select.options).forEach(function (option) {
          const testValues = values.slice();
          testValues[index] = option.value;
          const possible = variants.some(function (v) {
            if (!v.options) return false;
            return v.options.every(function (value, i) { return value === testValues[i]; });
          });
          option.disabled = !possible;
        });
      });
    }

    if (!variant) {
      // Do not falsely label every card SOLD OUT. Keep the first variant ID
      // available so Shopify can perform the authoritative inventory check.
      variant = variants[0];
    }

    idInput.value = variant.id;
    buttons.forEach(function (btn) {
      btn.disabled = false;
      btn.textContent = btn.classList.contains('buy-now-btn') ? 'BUY IT NOW' : 'ADD TO CART';
    });

    if (price && variant.price != null) {
      const currency = document.documentElement.dataset.currency || 'ZAR';
      try {
        price.textContent = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(variant.price / 100);
      } catch (_) {}
    }
  }

  document.querySelectorAll('[data-product-card]').forEach(function (card) {
    card.querySelectorAll('.variant-option').forEach(function (select) {
      select.addEventListener('change', function () { updateVariant(card); });
    });
    updateVariant(card);
  });


  // Quantity +/- controls
  document.querySelectorAll('.quantity-stepper').forEach(function (stepper) {
    const input = stepper.querySelector('.product-quantity');
    const minus = stepper.querySelector('.qty-minus');
    const plus = stepper.querySelector('.qty-plus');
    if (!input) return;

    function normalize() {
      let value = parseInt(input.value, 10);
      if (!Number.isFinite(value) || value < 1) value = 1;
      input.value = value;
    }

    if (minus) minus.addEventListener('click', function () {
      normalize();
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (plus) plus.addEventListener('click', function () {
      normalize();
      input.value = parseInt(input.value, 10) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    input.addEventListener('blur', normalize);
  });

  // Cart drawer — add items without leaving the current page.
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  const drawerItems = drawer && drawer.querySelector('[data-cart-items]');
  const drawerTotal = drawer && drawer.querySelector('[data-cart-total]');

  function money(cents) {
    try {
      const currency = document.documentElement.dataset.currency || 'ZAR';
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format((cents || 0) / 100);
    } catch (_) {
      return 'R' + ((cents || 0) / 100).toFixed(2);
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    if (overlay) overlay.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    });
    document.body.classList.add('cart-drawer-open');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    setTimeout(function () {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      if (overlay && !overlay.classList.contains('is-open')) overlay.hidden = true;
    }, 280);
  }

  function updateHeaderCartCount(count) {
    document.querySelectorAll('.links a[href$="/cart"]').forEach(function (link) {
      link.textContent = 'Cart (' + count + ')';
    });
  }

  // Use Shopify's native cart POST -> checkout flow. This is more reliable
  // than navigating directly to /checkout from a custom cart drawer.
  function submitNativeCheckout() {
    const cartUrl = document.body.dataset.cartUrl || '/cart';
    const form = document.createElement('form');
    form.method = 'post';
    form.action = cartUrl;
    form.style.display = 'none';
    const checkout = document.createElement('input');
    checkout.type = 'hidden';
    checkout.name = 'checkout';
    checkout.value = 'CHECKOUT';
    form.appendChild(checkout);
    document.body.appendChild(form);
    form.submit();
  }

  async function refreshCartDrawer() {
    if (!drawer || !drawerItems) return;
    try {
      const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!response.ok) throw new Error('Could not load cart.');
      const cart = await response.json();
      updateHeaderCartCount(cart.item_count);
      if (drawerTotal) drawerTotal.textContent = money(cart.total_price);

      if (!cart.items.length) {
        drawerItems.innerHTML = '<div class="leego-cart-empty"><div class="leego-cart-empty-icon">🛒</div><h3>Your cart is empty</h3><p>Add cartridges, ink or toner to get started.</p></div>';
        return;
      }

      drawerItems.innerHTML = cart.items.map(function (item) {
        const image = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '">' : '<div class="leego-cart-item-placeholder">LEEGO</div>';
        return '<div class="leego-cart-item">' +
          '<div class="leego-cart-item-image">' + image + '</div>' +
          '<div class="leego-cart-item-info">' +
            '<h3>' + escapeHtml(item.product_title) + '</h3>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="leego-cart-variant">' + escapeHtml(item.variant_title) + '</div>' : '') +
            '<div class="leego-cart-item-bottom"><strong>' + money(item.final_line_price) + '</strong></div>' +
            '<div class="leego-cart-item-actions"><div class="leego-drawer-qty"><button type="button" data-drawer-minus data-line="' + item.key + '" aria-label="Decrease quantity">−</button><span>' + item.quantity + '</span><button type="button" data-drawer-plus data-line="' + item.key + '" aria-label="Increase quantity">+</button></div><button type="button" class="leego-drawer-remove" data-drawer-remove data-line="' + item.key + '">Remove</button></div>' +
          '</div>' +
        '</div>';
      }).join('');
    } catch (error) {
      console.error('LEEGO cart drawer error:', error);
      drawerItems.innerHTML = '<div class="leego-cart-empty"><h3>Cart unavailable</h3><p>Please refresh and try again.</p></div>';
    }
  }

  if (drawer) {
    drawer.addEventListener('click', function (event) {
      if (event.target.closest('[data-cart-close]')) closeDrawer();
    });
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
    const checkoutForm = drawer.querySelector('.leego-checkout-form');
    if (checkoutForm) {
      checkoutForm.addEventListener('submit', function (event) {
        event.preventDefault();
        submitNativeCheckout();
      });
    }
  }

  async function changeDrawerLine(key, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        body: JSON.stringify({id:key, quantity:quantity}),
        credentials:'same-origin'
      });
      if (!response.ok) throw new Error('Could not update the cart.');
      await refreshCartDrawer();
    } catch (error) {
      console.error('LEEGO cart update error:', error);
    }
  }

  if (drawerItems) {
    drawerItems.addEventListener('click', function(event) {
      const plus = event.target.closest('[data-drawer-plus]');
      const minus = event.target.closest('[data-drawer-minus]');
      const remove = event.target.closest('[data-drawer-remove]');
      if (!plus && !minus && !remove) return;
      const key = (plus || minus || remove).getAttribute('data-line');
      const row = (plus || minus || remove).closest('.leego-cart-item');
      const qtyText = row && row.querySelector('.leego-drawer-qty span');
      const current = qtyText ? parseInt(qtyText.textContent, 10) || 1 : 1;
      changeDrawerLine(key, remove ? 0 : (plus ? current + 1 : Math.max(1, current - 1)));
    });
  }

  // Initial cart state for the drawer/count.
  refreshCartDrawer();

  // AJAX add-to-cart. Use Shopify's JSON endpoint explicitly so the page never navigates.
  document.addEventListener('submit', async function (event) {
    const form = event.target.closest('form.leego-add-to-cart');
    if (!form) return;
    event.preventDefault();

    const button = event.submitter || form.querySelector('button[type="submit"]');
    const buyNow = button && button.classList.contains('buy-now-btn');
    const idInput = form.querySelector('input[name="id"], select[name="id"]');
    const quantityInput = form.querySelector('input[name="quantity"]');
    if (!button || button.disabled) return;
    if (!idInput || !idInput.value) {
      return;
    }

    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'ADDING…';

    try {
      const body = new FormData();
      body.append('id', idInput.value);
      body.append('quantity', quantityInput && quantityInput.value ? quantityInput.value : '1');

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body,
        credentials: 'same-origin'
      });

      if (!response.ok) {
        let message = 'Could not add this product to your cart.';
        try {
          const data = await response.json();
          if (data && (data.description || data.message)) message = data.description || data.message;
        } catch (_) {}
        throw new Error(message);
      }

      // Refresh the drawer from Shopify's live cart, then open it.
      button.textContent = 'ADDED ✓';
      await refreshCartDrawer();
      if (buyNow) {
        submitNativeCheckout();
        return;
      }
      openDrawer();

      setTimeout(function () {
        if (button && document.body.contains(button)) {
          button.disabled = false;
          button.textContent = original;
        }
      }, 700);
    } catch (error) {
      console.error('LEEGO cart error:', error);
      alert(error.message || 'We could not add this product to your cart. Please try again.');
      button.disabled = false;
      button.textContent = original;
    }
  });


  // Best-sellers marquee: force a continuous automatic scroll and use the section setting for speed.
  document.querySelectorAll('[data-best-sellers-marquee]').forEach(function (marquee) {
    const track = marquee.querySelector('.best-sellers-track');
    if (!track) return;
    const seconds = Number(marquee.getAttribute('data-speed')) || 24;
    track.style.animationDuration = Math.max(18, Math.min(60, seconds)) + 's';
    track.style.animationPlayState = 'running';
  });

  // Predictive cartridge search: show matching products while the customer types.
  // Prefix matches are deliberately shown first, so typing "4" immediately
  // surfaces cartridge/product numbers beginning with 4.
  (function initPredictiveSearch() {
    const forms = Array.from(document.querySelectorAll('[data-predictive-search-form]'));
    if (!forms.length) return;
    let activeRequest = 0;

    function moneyText(value) {
      if (value == null || value === '') return '';
      const raw = String(value).replace(/<[^>]*>/g, '');
      if (/R\s?\d/.test(raw)) return raw;
      const n = Number(raw);
      if (!Number.isFinite(n)) return raw;
      try { return new Intl.NumberFormat('en-ZA', {style:'currency', currency: document.documentElement.dataset.currency || 'ZAR'}).format(n / 100); } catch (_) { return 'R' + (n / 100).toFixed(2); }
    }

    function imageUrl(product) {
      const image = product && product.featured_image;
      if (!image) return '';
      if (typeof image === 'string') return image;
      return image.url || image.src || '';
    }

    function escape(value) {
      return String(value == null ? '' : value)
        .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
        .replace(/"/g,'&quot;').replace(/'/g,'&#039;');
    }

    function productUrl(product) {
      return product ? (product.url || (product.handle ? '/products/' + product.handle : '#')) : '#';
    }

    function getProducts(data) {
      return (data && data.resources && data.resources.results && data.resources.results.products) || [];
    }

    function localProducts() {
      const node = document.getElementById('leego-product-index');
      if (!node) return [];
      try { return (JSON.parse(node.textContent || '{}').products || []); } catch (_) { return []; }
    }

    function searchableText(product) {
      return [product.title, product.vendor, product.handle, product.product_type]
        .filter(Boolean).join(' ').toLowerCase().trim();
    }

    function rankProducts(products, term) {
      const q = String(term || '').toLowerCase().trim();
      if (!q) return [];
      const seen = new Set();
      return products
        .filter(Boolean)
        .filter(function(product) {
          const key = product.handle || product.url || product.id || product.title;
          if (seen.has(key)) return false;
          seen.add(key);
          return searchableText(product).indexOf(q) !== -1;
        })
        .sort(function(a,b) {
          const aa = searchableText(a), bb = searchableText(b);
          const at = String(a.title || '').toLowerCase();
          const bt = String(b.title || '').toLowerCase();

          // Strongest match: title starts with the typed text.
          const ap = at.indexOf(q) === 0 ? 0 : 1;
          const bp = bt.indexOf(q) === 0 ? 0 : 1;
          if (ap !== bp) return ap - bp;

          // Next: any word/token in the title starts with the typed text.
          const aw = at.split(/[\s\-_/.,()]+/).some(function(x){ return x.indexOf(q) === 0; });
          const bw = bt.split(/[\s\-_/.,()]+/).some(function(x){ return x.indexOf(q) === 0; });
          if (aw !== bw) return aw ? -1 : 1;

          return at.localeCompare(bt);
        })
        .slice(0, 10);
    }

    function localMatch(term) {
      return rankProducts(localProducts(), term);
    }

    function render(products, term) {
      const list = rankProducts(products, term);
      const results = arguments[2];
      if (!results) return;
      if (!list.length) {
        results.innerHTML = '<div class="leego-suggest-empty">No matching cartridge found. Try a cartridge number such as <strong>4</strong>, <strong>953XL</strong> or <strong>106A</strong>.</div>';
        results.hidden = false;
        return;
      }

      results.innerHTML = '<div class="leego-suggest-heading">Matching cartridges & toners</div>' + list.map(function(product){
        const img = imageUrl(product);
        const price = product.price != null ? moneyText(product.price) : (product.price_min != null ? moneyText(product.price_min) : '');
        const safeUrl = escape(productUrl(product));
        return '<a class="leego-suggest-item" href="' + safeUrl + '">' +
          (img ? '<img class="leego-suggest-image" src="' + escape(img) + '" alt="" loading="lazy">' : '<div class="leego-suggest-image placeholder">LEEGO</div>') +
          '<span class="leego-suggest-copy"><span class="leego-suggest-title">' + escape(product.title) + '</span>' +
          (product.vendor ? '<span class="leego-suggest-meta">' + escape(product.vendor) + '</span>' : '') + '</span>' +
          (price ? '<span class="leego-suggest-price">' + escape(price) + '</span>' : '') +
        '</a>';
      }).join('') + '<a class="leego-suggest-viewall" href="/search?q=' + encodeURIComponent(term) + '&type=product">VIEW ALL RESULTS</a>';
      results.hidden = false;
    }

    function closeAll(except) {
      forms.forEach(function(form){
        const box = form.querySelector('[data-predictive-results]');
        if (box && box !== except) box.hidden = true;
      });
    }

    forms.forEach(function(form){
      const input = form.querySelector('[data-predictive-search-input]');
      const results = form.querySelector('[data-predictive-results]');
      if (!input || !results) return;
      let timer;

      input.addEventListener('input', function(){
        clearTimeout(timer);
        const term = input.value.trim();
        if (term.length < 1) { results.hidden = true; results.innerHTML = ''; return; }

        closeAll(results);
        // Give instant local prefix results while Shopify searches.
        const instant = localMatch(term);
        results.innerHTML = instant.length
          ? '<div class="leego-suggest-heading">Matching cartridges & toners</div>' + instant.map(function(product){
              const img=imageUrl(product), price=product.price!=null?moneyText(product.price):'';
              return '<a class="leego-suggest-item" href="'+escape(productUrl(product))+'">'+
                (img?'<img class="leego-suggest-image" src="'+escape(img)+'" alt="" loading="lazy">':'<div class="leego-suggest-image placeholder">LEEGO</div>')+
                '<span class="leego-suggest-copy"><span class="leego-suggest-title">'+escape(product.title)+'</span>'+
                (product.vendor?'<span class="leego-suggest-meta">'+escape(product.vendor)+'</span>':'')+
                '</span>'+(price?'<span class="leego-suggest-price">'+escape(price)+'</span>':'')+
                '</a>';
            }).join('') + '<a class="leego-suggest-viewall" href="/search?q='+encodeURIComponent(term)+'&type=product">VIEW ALL RESULTS</a>'
          : '<div class="leego-suggest-loading">Finding cartridges for “' + escape(term) + '”…</div>';
        results.hidden = false;

        timer = setTimeout(async function(){
          const requestId = ++activeRequest;
          try {
            const url = '/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor';
            const response = await fetch(url, {headers:{'Accept':'application/json'}, credentials:'same-origin'});
            if (!response.ok) throw new Error('Predictive search unavailable');
            const data = await response.json();
            if (requestId !== activeRequest || input.value.trim() !== term) return;

            // Merge Shopify's live results with the local index, then rank
            // true prefix matches first. This keeps the dropdown useful even
            // when Shopify's search ranking does not put "4..." first.
            const merged = getProducts(data).concat(localProducts());
            render(merged, term, results);
          } catch (error) {
            if (requestId === activeRequest && input.value.trim() === term) {
              render(localMatch(term), term, results);
            }
          }
        }, 70);
      });

      input.addEventListener('focus', function(){
        if (input.value.trim().length >= 1 && results.innerHTML) {
          closeAll(results); results.hidden = false;
        }
      });
      input.addEventListener('keydown', function(event){
        if (event.key === 'Escape') results.hidden = true;
      });
    });

    document.addEventListener('click', function(event){
      if (!event.target.closest('[data-predictive-search-form]')) closeAll(null);
    });
  })();

});
